import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import './TopNavD7.scss';

const splitMessages = (val) => {
  if (!val) return [];
  if (Array.isArray(val)) return val.filter(Boolean).map((s) => String(s).trim()).filter(Boolean);
  const str = String(val);
  // Accept common separators coming from admin/backoffice.
  return str
    .split(/\s*(?:\||\u2022|;|\n)\s*/g)
    .map((s) => s.trim())
    .filter(Boolean);
};

const getTopbarMessages = (client) => {
  const fromArray =
    splitMessages(client?.topbar_messages) ||
    splitMessages(client?.topbarMessages) ||
    splitMessages(client?.top_messages) ||
    splitMessages(client?.topMessages);
  if (fromArray?.length) return fromArray;

  const left = client?.top_message_left ?? client?.topMessageLeft ?? client?.topbar_left ?? client?.topbarLeft;
  const center = client?.top_message_center ?? client?.topMessageCenter ?? client?.topbar_center ?? client?.topbarCenter;
  const msgs = [left, center].filter(Boolean).map((s) => String(s).trim()).filter(Boolean);
  if (msgs.length) return msgs;

  // No hardcode: fallback to something provided by the API.
  return splitMessages(client?.name_show);
};

const getTopbarPhrase = (client, envios) => {
  // Pedido: mostrar siempre este mensaje cuando hay envios habilitados.
  const hasEnvios = Array.isArray(envios) ? envios.length > 0 : false;
  if (hasEnvios) return 'Envios a todo el pais';

  // Prefer admin-provided phrases
  const candidates = [
    client?.topbar_phrase,
    client?.topbarPhrase,
    client?.top_message_center,
    client?.topMessageCenter,
    client?.top_message_left,
    client?.topMessageLeft,
  ].filter(Boolean);
  if (candidates.length) return String(candidates[0]).trim();

  const msgs = getTopbarMessages(client);
  if (msgs?.length) return String(msgs[0]).trim();

  return String(client?.name_show || '').trim();
};

const TopNavD7 = ({ client, envios }) => {
  const phrase = useMemo(() => getTopbarPhrase(client, envios), [client, envios]);
  if (!phrase) return null;

  return (
    <div className="topbar top-nav-d7" data-testid="topnav-d7">
      <div className="d7-topbar__center" aria-label="Avisos">
        {phrase}
      </div>
    </div>
  );
};

TopNavD7.propTypes = { client: PropTypes.shape(), envios: PropTypes.arrayOf(PropTypes.shape()) };
TopNavD7.defaultProps = { client: null, envios: null };

export default TopNavD7;
